import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { useAccount } from "wagmi";
import { formatEther, formatUnits } from "viem";
import { Button } from "@/src/components";
import { ConnectButton } from "@/src/components/connectButton";
import { useBalances } from "@/src/hooks/useBalances";
import { useFrbBalances } from "@/src/hooks/useBalances";
import { useFarms } from "@/src/hooks/useFarms";
import { useStake } from "@/src/hooks/useStake";
import { toast } from "react-hot-toast";
import { shortenAddress } from "@/src/lib/address";
import { LiquidityButton } from "@/src/views/home";
import { activeChain } from "@/src/configs/chainConfig"; 


export const FlareBurn2Mint = () => {
  const { chain } = useAccount();
  const { onStakeCanary, onUnstakeCanary, onBurn2Mint, onBurn2MintLp, onBurn2MintNfts } = useStake();
  const { address, isConnected } = useAccount();
  const { balance, trbBalance } = useBalances();
  const { userCap, burnedAmount, frbMinted } = useFarms();
  const {userLpBalance, crbLPAmount, trbLpBalance, nftAvailable, bronzeAvailable, silverAvailable, goldAvailable} = useFrbBalances();
  const submitButtonRef = useRef(null);
  const submitButtonRefLp = useRef(null);
  const [{ isStake, placeholder }, setOption] = useState({
    isStake: true,
    placeholder: "Amount to burn",
  });
  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  console.log(parseFloat(nftAvailable));
  console.log(parseInt(silverAvailable));
  console.log(parseFloat(bronzeAvailable));
  console.log(parseFloat(goldAvailable));

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });
    
  }, [chain, isConnected]);

  const [{ stakeInput, unstakeInput }, setInput] = useState({
    stakeInput: "",
    unstakeInput: "",
  });
    const [{ stakeInputLp, unstakeInputLp }, setInputLp] = useState({
    stakeInputLp: "",
    unstakeInputLp: "",
  });
  useEffect(() => {
    submitButtonRef.current &&
      (() => {
        submitButtonRef.current.disabled = true;
        if ( !isCorrectChain ) {
          submitButtonRef.current.innerHTML = "Wrong Network";
          return;
        }

        if (isStake) {
          if ((stakeInput == 0) ) {
            submitButtonRef.current.innerHTML = "Enter Quantity";
            return;
          }
          if ((trbBalance == 0 || stakeInput > trbBalance) ) {
            submitButtonRef.current.innerHTML = "Insufficient balance";
            return;
          }
          if ( !isCorrectChain ) {
            submitButtonRef.current.innerHTML = "Wrong Network";
            return;
          }
          if (stakeInput) {
            submitButtonRef.current.innerHTML = "Burn CRB";
            submitButtonRef.current.disabled = false;
            return;
          }
          submitButtonRef.current.innerHTML = "Enter quantity";

          return;
        }

        submitButtonRef.current.innerHTML = "Enter quantity";
          return;
      })();
  }, [isStake, stakeInput, unstakeInput, balance, trbBalance]);
    useEffect(() => {
    submitButtonRefLp.current &&
      (() => {
        submitButtonRefLp.current.disabled = true;
        if ( !isCorrectChain ) {
          submitButtonRefLp.current.innerHTML = "Wrong Network";
          return;
        }

        if (isStake) {
          if ((stakeInputLp == 0) ) {
            submitButtonRefLp.current.innerHTML = "Enter Quantity";
            return;
          }
          if ((trbLpBalance == 0 || stakeInputLp > trbLpBalance) ) {
            submitButtonRefLp.current.innerHTML = "Insufficient balance";
            return;
          }
          if ( !isCorrectChain ) {
            submitButtonRefLp.current.innerHTML = "Wrong Network";
            return;
          }
          if (stakeInputLp) {
            submitButtonRefLp.current.innerHTML = "Burn LP Tokens";
            submitButtonRefLp.current.disabled = false;
            return;
          }
          submitButtonRefLp.current.innerHTML = "Enter quantity";

          return;
        }

        submitButtonRefLp.current.innerHTML = "Enter quantity";
          return;
      })();
  }, [isStake, stakeInputLp, unstakeInputLp, userLpBalance, trbBalance, trbLpBalance]);

  const onInputChange = (event) => {
    const value = event.target.valueAsNumber;
    const _stakeInput = isStake ? value : stakeInput;
    const _unstakeInput = isStake ? unstakeInput : value;
    setInput({
      stakeInput: _stakeInput,
      unstakeInput: _unstakeInput,
    });
  };
  const onInputChangeLp = (event) => {
    const value = event.target.valueAsNumber;
    const _stakeInput = isStake ? value : stakeInputLp;
    const _unstakeInput = isStake ? unstakeInput : value;
    setInputLp({
      stakeInputLp: _stakeInput,
      unstakeInputLp: _unstakeInput,
    });
  };
  const onUnstake = () => {
    setOption({
      isStake: false,
      placeholder: "Amount to unstake",
    });
  };
  const onStake = () => {
    setOption({
      isStake: true,
      placeholder: "Amount to burn",
    });
  };

  const onMaxBalance = () => {
    if (isStake)
      return setInput((prev) => ({
        ...prev,
        stakeInput: trbBalance,
      }));
    setInput((prev) => ({
      ...prev,
      unstakeInput: trbBalance,
    }));
  };
    const onMaxBalanceLp = () => {
    if (isStake)
      return setInputLp((prev) => ({
        ...prev,
        stakeInputLp: trbLpBalance,
      }));
    setInputLp((prev) => ({
      ...prev,
      unstakeInputLp: trbLpBalance,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isStake)
      return toast.promise(onBurn2Mint(stakeInput), {
        loading: "Transaction is in progress",
        success: "Successfully burned CRB",
        error: (data) => data,
      });
  };
    const handleSubmitLp = async (event) => {
    event.preventDefault();

    if (isStake)
      return toast.promise(onBurn2MintLp(stakeInputLp), {
        loading: "Transaction is in progress",
        success: "Successfully burned LP tokens",
        error: (data) => data,
      });
  };
    const handleSubmitNft = async (event) => {
    event.preventDefault();

    if (isStake)
      return toast.promise(onBurn2MintNfts(), {
        loading: "Transaction is in progress",
        success: "Successfully burned NFTs",
        error: (data) => data,
      });
  };
  return (
    <div className="md:border-2 border-foreground/10 max-w-xl mx-auto w-full rounded-md md:p-8">
      <div className="text-foreground/50">
      <p>Carefully read the burn2mint and airdrop structure before burning your CRB, LP Tokens or NFTs <u><b><a target="_blank" href="https://docs.canary-reborn.xyz/songbird/flare-migration">here</a></b></u>.</p>
    </div> 
      <form onSubmit={handleSubmit}>
        <div className="mt-8 p-1 pr-0">
          <div className="flex w-full">
            <input
              value={stakeInput}
              max={trbBalance}
              onChange={onInputChange}
              placeholder={placeholder}
              className="text-foreground font-medium w-[80%] rounded-md rounded-tr-none rounded-br-none border-[3px] border-primary/60 border-r-0 bg-background hover:border-primary outline-0 px-3"
              type="number"
              required
            />

            <span className="w-1/5">
              <Button
                type="button"
                onClick={onMaxBalance}
                className="rounded-tl-none rounded-bl-none"
              >
                max
              </Button>
            </span>
          </div>
        </div>
        <div className="flex justify-center py-2 text-foreground/50">
        <table>
            <tr>
              <td>
                <p><b>CRB Balance:</b> </p> 
              </td>
              <td>
              <p>{parseFloat(trbBalance).toFixed(2)}</p>
              </td>
            </tr>
            <div className="py-2" />
          </table>
          </div>
        <div className="border-t-2 border-foreground/30" />
        <div className="mt-10">
          {!isConnected && (
            <div className="flex justify-center">
              <ConnectButton />
            </div>
          )}
          {isConnected && <Button ref={submitButtonRef} type="submit">Burn CRB (Can only burn once with each NFT)</Button>}
          
        </div>
      </form>
       <form onSubmit={handleSubmitLp}>
        <div className="mt-8 p-1 pr-0">
          <div className="flex w-full">
            <input
              value={stakeInputLp}
              max={trbLpBalance}
              onChange={onInputChangeLp}
              placeholder={placeholder}
              className="text-foreground font-medium w-[80%] rounded-md rounded-tr-none rounded-br-none border-[3px] border-primary/60 border-r-0 bg-background hover:border-primary outline-0 px-3"
              type="number"
              required
            />

            <span className="w-1/5">
              <Button
                type="button"
                onClick={onMaxBalanceLp}
                className="rounded-tl-none rounded-bl-none"
              >
                max
              </Button>
            </span>
          </div>
        </div>
        <div className="flex justify-center py-2 text-foreground/50">
        <table>
            <tr>
              <td>
                <p><b>LP Balance (in CRB):</b> </p> 
              </td>
              <td>
              <p>{parseFloat(crbLPAmount).toFixed(2)}</p>
              </td>
            </tr>
                        <tr>
              <td>
                <p><b>LP Tokens:</b> </p> 
              </td>
              <td>
              <p>{parseFloat(trbLpBalance).toFixed(2)}</p>
              </td>
            </tr>
            <div className="py-2" />
          </table>
          </div>
        <div className="border-t-2 border-foreground/30" />
        <div className="mt-10">
          {!isConnected && (
            <div className="flex justify-center">
              <ConnectButton />
            </div>
          )}
          {isConnected && <Button ref={submitButtonRefLp} type="submit">Burn LP Tokens</Button>}
          
        </div>
      </form>
      <form onSubmit={handleSubmitNft}>
        <div className="flex justify-center py-2 text-foreground/50">
        <table>
            <tr>
              <td>
                <p><b>Reborn NFT FRB available to burn:</b> </p> 
              </td>
              <td>
              <p>{formatEther(nftAvailable)}</p>
              </td>
            </tr>
                        <tr>
              <td>
                <p><b>Bronze NFT FRB available to burn:</b> </p> 
              </td>
              <td>
              <p>{formatEther(bronzeAvailable)}</p>
              </td>
            </tr>
                        <tr>
              <td>
                <p><b>Silver NFT FRB available to burn:</b> </p> 
              </td>
              <td>
              <p>{formatEther(silverAvailable)}</p>
              </td>
            </tr>
                        <tr>
              <td>
                <p><b>Gold NFT FRB available to burn:</b> </p> 
              </td>
              <td>
              <p>{formatEther(goldAvailable)}</p>
              </td>
              <tr><td>
                <p> </p>
                </td>
                <td>
                <p> </p>
                </td></tr>
            </tr>
             <tr>
              <td>
                <p><b>NFTs are invalidated upon burning, however they are not transferred and remain visible in your wallet.</b> </p> 
              </td>

            </tr>
            <div className="py-2" />
          </table>
          </div>
        <div className="border-t-2 border-foreground/30" />
        <div className="mt-10">
          {!isConnected && (
            <div className="flex justify-center">
              <ConnectButton />
            </div>
          )}
          {isConnected && <Button type="submit" disabled={(parseFloat(bronzeAvailable)+parseFloat(silverAvailable)+parseFloat(goldAvailable)+parseFloat(nftAvailable))<= 0}>Burn all NFTs</Button>}
          
        </div>
      </form>
    </div>
  );
};
